import { render, staticRenderFns } from "./clients-tab.vue?vue&type=template&id=575857c4&scoped=true"
import script from "./clients-tab.vue?vue&type=script&lang=js"
export * from "./clients-tab.vue?vue&type=script&lang=js"
import style0 from "./clients-tab.vue?vue&type=style&index=0&id=575857c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575857c4",
  null
  
)

export default component.exports